import React from 'react';

import GridComponent from './GridComponent';

export default ({ children, ...props }) => (
  <GridComponent primaryClassName="Grid-cell" {...props}>
    <div className="Grid-cell-content">
      {children}
    </div>
  </GridComponent>
);



// WEBPACK FOOTER //
// ./src/components/basic/grid/GridCell.js